import { Scheduler } from "@aldabil/react-scheduler";
import {
  Button,
  Col,
  Divider,
  message,
  Row,
  Select,
  Space,
  Tooltip,
} from "antd";
import { differenceInMinutes, set } from "date-fns";
import { ButtonBase, Paper } from "@mui/material";
import { useCallback, useEffect, useRef, useState } from "react";
import icons from "../../Common/Icons";
import moment from "moment";
import api from "utils/api";
import CustomSchedulerEditor from "./CustomSchedulerEditor";
import AppointmentEventItem from "./AppointmentEventItem";
import { calcCellHeight, calcMinuteHeight } from "./SchedulerHelper";
import {
  AVAILABLE_CELL_COLOR,
  NON_AVAILABLE_CELL_COLOR,
  BORDER_HEIGHT,
  TABLE_HEIGHT,
  HOURS_LENGTH,
  STEP,
  START_HOUR,
  HOLIDAY_CELL_COLOR,
  APPOINTMENT_COLOR,
} from "Common/constant";
import "./MyAvailabilityNewVersion.scss";
import ShowAvailabilities from "./ShowAvailabilities";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { patientDetail } from "store/slice/patient-detail-slice";
// import { setSelectedTab } from "store/slice/appointment-slice";
import { AVAILABILITY_ADD_ACTION } from "Common/constant";
import MyHolidays from "./MyHolidays";
import { usertype } from "store/slice/patient-detail-slice";
import axios from "axios";
import AppointmentJoinModal from "Pages/Appointment/AppointmentJoinModal";
import Loader from "Components/Loader";
import { CONSTANTS } from "utils/constant";
import utils from "utils";
import dayjs from "dayjs";
import { END_HOUR } from "Common/constant";

const CELL_HEIGHT = calcCellHeight(TABLE_HEIGHT, HOURS_LENGTH);
const MINUTE_HEIGHT = calcMinuteHeight(CELL_HEIGHT, STEP);

let slotId = 0;

const getUniqueId = () => {
  slotId += 1;
  return slotId;
};

const transformMyAppointments = (appointments) => {
  const transformedAppts = appointments.map((appt) => {
    const startTime = new Date(appt.appointment_date_time);
    const momentObj = moment(startTime);

    const isDayEndAppt = startTime.getHours() == 23;

    return {
      ...appt,
      event_id: appt.appointment_id,
      start: momentObj
        .set({
          hour: startTime.getHours(),
          minute: startTime.getMinutes(),
          second: 0,
        })
        .toDate(),
      end: isDayEndAppt
        ? momentObj
            .set({
              hour: 23,
              minute: 59,
              second: 0,
            })
            .toDate()
        : momentObj
            .set({
              hour: startTime.getHours(),
              minute: startTime.getMinutes(),
              second: 0,
            })
            .add(1, "hours")
            .toDate(),
      endLabel: momentObj
        .set({
          hour: startTime.getHours(),
          minute: startTime.getMinutes(),
          second: 0,
        })
        .add(1, "hours")
        .toDate(),
      color: APPOINTMENT_COLOR,
      showJoin: appt.status == CONSTANTS.APPT_ACCEPTED_STS,
    };
  });

  return transformedAppts;
};

const transformMyAvailabilities = (
  availabilities,
  holidays,
  doc_offset_param
) => {
  const currentDateWRTTZ = doc_offset_param
    ? new Date(
        utils.FormatDate(
          utils.TimezoneOffsetConversionForPatient(doc_offset_param),
          "UTC"
        )
      )
    : new Date(
        dayjs(utils.TimezoneOffsetConversion()).format("YYYY-MM-DD HH:mm:ss")
      );

  const transformedAvailabilities = availabilities.map((availability) => {
    const startTime = new Date(availability.start_time);
    const endTime = new Date(availability.end_time);
    const dayOfWeek =
      moment(currentDateWRTTZ) >
      moment(currentDateWRTTZ).day(availability.day_of_week)
        ? moment(currentDateWRTTZ).add(1, "weeks").day(availability.day_of_week)
        : moment(currentDateWRTTZ).day(availability.day_of_week);

    return {
      id: getUniqueId(),
      dayName: availability.day_of_week,
      start: dayOfWeek
        .set({
          hour: startTime.getHours(),
          minute: startTime.getMinutes(),
          second: 0,
        })
        .toDate(),
      end: dayOfWeek
        .set({
          hour: endTime.getHours(),
          minute: endTime.getMinutes(),
          second: 0,
        })
        .toDate(),
      isHoliday: holidays.some((day) =>
        moment(dayOfWeek).isBetween(
          new Date(day.start_day),
          new Date(day.end_day),
          "days",
          "[]"
        )
      )
        ? "Y"
        : "N",
    };
  });

  transformedAvailabilities.sort(
    (a, b) => a.start.getTime() - b.start.getTime()
  );

  return transformedAvailabilities;
};

const MyAvailabilityNewVersion = () => {
  const temp_currentDTWRTTZ = new Date(
    dayjs(utils.TimezoneOffsetConversion()).format("YYYY-MM-DD HH:mm:ss")
  );

  const [currentDTWRTTZ, setCurrentDTWRTTZ] = useState(temp_currentDTWRTTZ);

  const [events, setEvents] = useState([]);

  const [loading, setLoading] = useState(false);

  const [isDataReady, setIsDataReady] = useState(false);

  const [holidayList, setHolidaysList] = useState([]);

  const [doctorId, setDoctorId] = useState(null);

  const [disableAddEdit, setDisableAddEdit] = useState(false);

  const [doctorsList, setDoctorsList] = useState([]);

  const [sltdDocOffset, setSltdDocOffset] = useState(null);

  const [isSaving, setIsSaving] = useState(false);

  const isTimeBarCellFound = useRef(false); // useRef for mutable values

  const [apptDetail, setApptDetail] = useState(null);

  const [showJoinModal, setShowJoinModal] = useState(false);

  const [isHolidayUpdtd, setHolidayUpdtd] = useState(false);

  const myAvailabilitiesRef = useRef([]);

  const timer = useRef(null);

  const history = useHistory();

  const dispatch = useDispatch();

  const user_details = useSelector((state) => state.loginReducer.user_details);

  // const [isMobileView, setIsMobileView] = useState(false);

  // const isInMobileView = useRef(false);

  // const handleResize = () => {
  //   if (window.innerWidth < 760 && !isInMobileView.current) {
  //     setIsMobileView(true);
  //     isInMobileView.current = true;
  //   }
  //   if (window.innerWidth > 760 && isInMobileView.current) {
  //     setIsMobileView(false);
  //     isInMobileView.current = false;
  //   }
  // };

  const constructAvailabilities = () => {
    return {
      ...(user_details.role === "care-admin" && { doctor_id: doctorId }),
      doctor_availability: myAvailabilitiesRef.current.map((availability) => {
        const startTime = moment(new Date(availability.start));
        const endTime = moment(new Date(availability.end));
        return {
          day_of_week: startTime.format("dddd"),
          start_time: startTime.format("YYYY-MM-DD HH:mm:ss"),
          end_time: endTime.format("YYYY-MM-DD HH:mm:ss"),
        };
      }),
    };
  };

  const handleApply = async (schedulerIns) => {
    const availabilities = constructAvailabilities();
    setIsSaving(true);
    api
      .addEdit_myAvailabilty_list(availabilities)
      .then((response) => {
        let { status, message: resmsge } = response.data || {};
        // utils.Modal(false);
        // utils.Toast({
        //   type: "success",
        //   message: utils.ConvertToPascalCase(message),
        // });
        if (resmsge == "please give valid inputs") {
          message.warning(resmsge, ErrorDuration);
        } else {
          message.success(resmsge, ErrorDuration);
        }
        schedulerIns.close();
        // this.getListAvailability();
        setIsSaving(false);
      })
      .catch((error) => {
        setIsSaving(false);
      });
  };

  const handleConfirm = (start, end, schedulerIns, availItemId) => {
    const day_name = moment(start).format("dddd");

    const availability = {
      id: getUniqueId(),
      dayName: day_name,
      start: moment(start).toDate(),
      end: moment(end).toDate(),
      isHoliday: "N",
    };
    if (availItemId) {
      const availabilityIndx = myAvailabilitiesRef.current.findIndex(
        (item) => item.id == availItemId
      );

      myAvailabilitiesRef.current.splice(availabilityIndx, 1, availability);
    } else {
      myAvailabilitiesRef.current = [
        ...myAvailabilitiesRef.current,
        availability,
      ];
    }

    const nonDayAvailSlots = myAvailabilitiesRef.current.filter(
      (item) => item.dayName != day_name
    );

    let dayAvailSlots = myAvailabilitiesRef.current.filter(
      (item) => item.dayName === day_name
    );

    dayAvailSlots.sort((a, b) => a.start.getTime() - b.start.getTime());

    let index = 0;
    let mrgdArray = [];

    for (let j = 1; j < dayAvailSlots.length; j++) {
      // if (
      //   dayAvailSlots[index].end.getHours() >= dayAvailSlots[j].start.getHours()
      // ) {
      if (
        dayAvailSlots[index].end.getTime() >= dayAvailSlots[j].start.getTime()
      ) {
        dayAvailSlots[index].end = moment
          .max(moment(dayAvailSlots[index].end), moment(dayAvailSlots[j].end))
          .toDate();
      } else {
        index++;
        dayAvailSlots[index] = dayAvailSlots[j];
      }
    }
    for (let i = 0; i <= index; i++) {
      mrgdArray.push(dayAvailSlots[i]);
    }
    myAvailabilitiesRef.current = [...nonDayAvailSlots, ...mrgdArray];
    handleApply(schedulerIns);
  };

  const handleDelete = (availItemId, schedulerIns) => {
    const availabilityIndx = myAvailabilitiesRef.current.findIndex(
      (item) => item.id === availItemId
    );
    myAvailabilitiesRef.current.splice(availabilityIndx, 1);
    handleApply(schedulerIns);
  };

  const timebarCellRef = useCallback((node) => {
    if (node !== null) {
      node.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "start",
      });
    }
  }, []);

  const handleJoinNow = (appt) => {
    setApptDetail(appt);
    setShowJoinModal(true);
  };

  const listDoctors = () => {
    setLoading(true);
    api
      .list_doctors()
      .then((res) => {
        let { results = [] } = res.data?.data;

        let data = results.map((item) => {
          return {
            name: item.doctor_name,
            value: item.doctor_id,
            specilization: item.doctor_specialization,
            regNo: item.registration_number,
            offset: item.doctor_timezone_offset_in_min,
          };
        });
        setDoctorsList(data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const getAllData = (doctorId = null, doc_offset_param = null) => {
    // setLoading(true);
    api
      .doctor_schedule_list(doctorId)
      .then((response) => {
        let { availability_list: availData } = response?.data?.data;
        let { holiday_list: holidaysData } = response?.data?.data;
        let { appointment_list: apptsData } = response?.data?.data;
        setHolidaysList(holidaysData);
        myAvailabilitiesRef.current = transformMyAvailabilities(
          availData,
          holidaysData,
          doc_offset_param
        );
        setEvents(transformMyAppointments(apptsData));
        setLoading(false);
        setIsDataReady(true);
        setHolidayUpdtd(false);
      })
      .catch((error) => {
        myAvailabilitiesRef.current = [];
        setHolidaysList([]);
        setEvents([]);
        setLoading(false);
        setHolidayUpdtd(false);
        message.error("Oops! something went wrong", ErrorDuration);
        console.log(error);
      });
  };

  const setPatientDetail = (patient_id) => {
    dispatch(patientDetail(patient_id));
  };

  const handleDoctorChange = (value) => {
    setLoading(true);
    const doctor_offset = doctorsList.find(
      (item) => item.value == value
    )?.offset;

    const doc_currentDTWRTTZ = new Date(
      utils.FormatDate(
        utils.TimezoneOffsetConversionForPatient(doctor_offset),
        "UTC"
      )
    );
    setCurrentDTWRTTZ(doc_currentDTWRTTZ);
    setSltdDocOffset(doctor_offset);
    if (value) {
      setIsDataReady(false);
      setDoctorId(value);
      setDisableAddEdit(false);
      timer.current = setTimeout(() => {
        getAllData(value, doctor_offset);
      }, 1000);
    } else {
      myAvailabilitiesRef.current = [];
      setCurrentDTWRTTZ(temp_currentDTWRTTZ);
      setHolidaysList([]);
      setEvents([]);
      setIsDataReady(false);
      setDoctorId(null);
      setSltdDocOffset(null);
      setDisableAddEdit(true);
      timer.current = setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  useEffect(() => {
    if (isHolidayUpdtd) {
      setLoading(true);
      if (user_details.role === "care-admin") {
        getAllData(doctorId, sltdDocOffset);
      } else {
        getAllData(doctorId);
      }
    }
  }, [isHolidayUpdtd]);

  useEffect(() => {
    if (user_details.role === "care-admin") {
      setDisableAddEdit(true);
      listDoctors();
    } else {
      setLoading(true);
      getAllData();
    }

    return () => {
      if (timer.current) {
        clearTimeout(timer.current);
      }
      setEvents([]);
      setHolidaysList([]);
      myAvailabilitiesRef.current = [];
    };

    // getData();
    // handleResize();
    // window.addEventListener("resize", handleResize);
    // return () => {
    //   window.removeEventListener("resize", handleResize);
    // };
  }, []);

  return (
    <>
      <div className="calendar_button_div calendar">
        <Row align="middle">
          {user_details.role === "care-admin" && (
            <Col span={10}>
              <Select
                style={{ width: "80%" }}
                showSearch
                allowClear
                placeholder="Please Select a Doctor"
                optionFilterProp="children"
                optionLabelProp="label"
                onChange={handleDoctorChange}
                // onSearch={handleDoctorChange}
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                // options={doctorsList}
              >
                {doctorsList.map((item) => (
                  <Select.Option value={item.value} label={item.name}>
                    <Tooltip
                      title={
                        item?.specilization
                          ? `${item.name} ${
                              item.specilization
                                ? "| " + item.specilization
                                : ""
                            }  ${item.regNo ? "| " + item.regNo : ""}`
                          : `${item.name}`
                      }
                      overlayStyle={{
                        size: "30px",
                        color: "blue",
                        backgroundColor: "rea",
                        minWidth: "fit-content",
                      }}
                      placement="right"
                    >
                      <div className="option-section">
                        <span className="name">{item.name}</span>
                        {item.specilization && item.regNo && (
                          <span className="doctor-specl-regno">
                            {` ${item.specilization} | ${item.regNo}`}
                          </span>
                        )}
                      </div>
                    </Tooltip>
                    <Divider style={{ margin: "0px", padding: "0px" }} />
                  </Select.Option>
                ))}
              </Select>
            </Col>
          )}

          <Col span={6}>
            {isDataReady && (
              <MyHolidays
                isHolidayUpdtd={isHolidayUpdtd}
                setHolidayUpdtd={setHolidayUpdtd}
                doctorId={doctorId}
              />
            )}
          </Col>
          {/* <Col span={2} offset={10}>
            {isDataReady && (
              <div
                onClick={handleApply}
                // type="primary"
                className="button-arrow"
              >
                {isSaving ? "Submit..." : "Submit"}
                <img src={icons.right_arrow_dashboard} />
              </div>
            )}
          </Col> */}
        </Row>
        {(sltdDocOffset == 0 || sltdDocOffset) && !loading && (
          <Row>
            <Col>
              <div
                style={{
                  padding: "8px 0px 0px 8px",
                  color: "#F38744",
                  fontSize: "14px",
                }}
              >
                *Slots displayed based on doctor time zone
                {utils.convertToTime(sltdDocOffset)}
              </div>
            </Col>
          </Row>
        )}

        {showJoinModal && (
          <AppointmentJoinModal
            patient_last_name={apptDetail?.patient_last_name}
            setShowJoinModal={setShowJoinModal}
            apptDetail={apptDetail}
            role={user_details.role}
            is_video_call={apptDetail?.is_video_call}
          />
        )}
      </div>

      {loading ? (
        <Loader />
      ) : (
        <Scheduler
          height={200}
          events={events}
          selectedDate={currentDTWRTTZ}
          month={null}
          day={null}
          navigation={false}
          draggable={false}
          week={{
            weekDays: [0, 1, 2, 3, 4, 5, 6],
            weekStartOn: currentDTWRTTZ.getDay(),
            startHour: START_HOUR,
            endHour: END_HOUR,
            step: STEP,
            cellRenderer: ({ height, start, end, onClick, ...props }) => {
              let isTimebarCell = false;
              const dayName = moment(new Date(start)).format("dddd");
              const dayAvailabilities = myAvailabilitiesRef.current.filter(
                (availability) => availability.dayName === dayName
              );
              let isAvailCell = dayAvailabilities.some((day) =>
                moment(new Date(start)).isBetween(
                  new Date(day.start),
                  new Date(day.end),
                  "minutes",
                  "[)"
                )
              );

              let isHolidayCell =
                dayAvailabilities.length > 0
                  ? dayAvailabilities.some((day) => day.isHoliday === "Y")
                  : holidayList.some((day) =>
                      moment(new Date(start)).isBetween(
                        new Date(day.start_day),
                        new Date(day.end_day),
                        "days",
                        "[]"
                      )
                    );

              if (!isTimeBarCellFound.current) {
                if (
                  moment(new Date(currentDTWRTTZ)).isBetween(
                    new Date(start),
                    new Date(end),
                    "minutes",
                    "[]"
                  )
                ) {
                  isTimebarCell = true;
                  isTimeBarCellFound.current = true;
                }
              }

              return (
                <>
                  <Paper
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "block",
                      overflow: "hidden",
                      borderRadius: 0,
                      background: "transparent",
                      boxShadow: "none",
                    }}
                  >
                    {isAvailCell && !isHolidayCell && (
                      <ShowAvailabilities
                        // key={start + end}
                        dayAvailabilities={dayAvailabilities}
                      />
                    )}
                    <ButtonBase
                      {...(isTimebarCell && {
                        ref: timebarCellRef,
                      })}
                      disabled={isHolidayCell || disableAddEdit}
                      onClick={onClick}
                      style={{
                        width: isAvailCell && !isHolidayCell ? "88%" : "98%",
                        height: "100%",
                        background: isHolidayCell
                          ? HOLIDAY_CELL_COLOR
                          : isAvailCell
                          ? AVAILABLE_CELL_COLOR
                          : NON_AVAILABLE_CELL_COLOR,
                      }}
                      // {...props}
                    >
                      <div
                        style={{
                          height: "100%",
                        }}
                      ></div>
                    </ButtonBase>
                  </Paper>
                </>
              );
            },
          }}
          customEditor={(scheduler) => (
            <CustomSchedulerEditor
              scheduler={scheduler}
              handleConfirm={handleConfirm}
              handleDelete={handleDelete}
              availabilities={myAvailabilitiesRef}
            />
          )}
          eventRenderer={({ event }) => {
            const height =
              differenceInMinutes(event.end, event.start) * MINUTE_HEIGHT -
              BORDER_HEIGHT;

            const minituesFromTop = differenceInMinutes(
              event.start,
              set(event.start, {
                hours: START_HOUR,
                minutes: 0,
              })
            );
            const topSpace = minituesFromTop * MINUTE_HEIGHT;
            // const slotsFromTop = minituesFromTop / STEP;
            // const borderFactor = slotsFromTop + BORDER_HEIGHT;
            // const top = topSpace + borderFactor;
            // const bottom = (1.5 / 100) * top;
            if (top < 0) {
              return null;
            }

            return (
              <div
                style={{
                  height: height,
                  width: "100%",
                  position: "absolute",
                  top: topSpace,
                }}
              >
                <AppointmentEventItem
                  event={event}
                  handleJoinNow={handleJoinNow}
                  user_details={user_details}
                  setPatientDetail={setPatientDetail}
                />
              </div>
            );
          }}
        />
      )}

      {/* mobile view scheduler */}

      {/* {myAvailabilitiesRef.current.length > 0 && isMobileView && (
          <Scheduler
            height={200}
            events={events}
            month={null}
            week={null}
            navigation={true}
            draggable={false}
            // loading={confirming}
            navigationPickerProps={{
              disablePast: true,
            }}
            day={{
              startHour: START_HOUR,
              endHour: 23,
              endHour: 23,
              step: STEP,
              cellRenderer: ({ height, start, end, onClick, ...props }) => {
                let isTimebarCell = false;
                const dayName = moment(new Date(start)).format("dddd");
                const dayAvailabilities = myAvailabilitiesRef.current.filter(
                  (availability) => availability.dayName === dayName
                );
                let isAvailCell = dayAvailabilities.some((day) =>
                  moment(new Date(start)).isBetween(
                    new Date(day.start),
                    new Date(day.end),
                    "minutes",
                    "[)"
                  )
                );
                if (!isTimeBarCellFound.current) {
                  if (
                    moment(new Date()).isBetween(
                      new Date(start),
                      new Date(end),
                      "minutes",
                      "[]"
                    )
                  ) {
                    isTimebarCell = true;
                    isTimeBarCellFound.current = true;
                  }
                }

                return (
                  <MUIButton
                    {...(isTimebarCell && {
                      ref: timebarCellRef,
                    })}
                    style={{
                      height: "100%",
                      background: isAvailCell
                        ? AVAILABLE_CELL_COLOR
                        : NON_AVAILABLE_CELL_COLOR,
                    }}
                    onClick={onClick}
                    // {...props}
                  ></MUIButton>
                );
              },
            }}
            customEditor={(scheduler) => <CustomSchedulerEditor scheduler={scheduler} />}
            eventRenderer={(event) => {
              const minituesFromTop = differenceInMinutes(
                event.start,
                setHours(event.start, START_HOUR)
              );
              const topSpace = minituesFromTop * MINUTE_HEIGHT;
              const slotsFromTop = minituesFromTop / STEP;
              const borderFactor = slotsFromTop + BORDER_HEIGHT;
              const top = topSpace + borderFactor;
              const bottom = (1.5 / 100) * top;

              if (top < 0) {
                return null;
              }
              return (
                <div
                  style={{
                    height: "100%",
                    position: "relative",
                    bottom: bottom,
                  }}
                >
                  <AppointmentEventItem event={event} />
                </div>
              );
            }}
          />
        )} */}
    </>
  );
};

export default MyAvailabilityNewVersion;
